import {api} from "../http/apiClient"

const ApiCompaniesSizes = () => {
  const getCompaniesSizes = (cnpj) => {
    return api.get(`/porte/`, {
      params: {
        cnpj,
      },
    })
  }

  return { getCompaniesSizes }
}

export default ApiCompaniesSizes
